module.exports = __webpack_public_path__ + "img/about_4.17c473fc.jpg";